<template>
	<div class="res_box">
		<p class="back_box" @click="back()">
			<img src="../../../static/images/back.png" alt=""> 返回上一页
		</p>
		<h2>开始救援</h2>
		<div class="step_box">
			<p style="font-weight: 600;">案件详情</p>
			<ParheaderVue :caseid="caseid" :token="token"/>
			<Parinf :dataArr="caseObj" :token="token"/>
			<p style="font-weight: 600;">流程示意</p>
			<process :serviceLst=stepdata.slice(1,stepdata.length) :serviceIndex='el_index'></process>
			<p style="font-weight: 600;">服务清单</p>
			<div class="det_box">
				<ul class="ul">
					<li v-for="(v,ind) in stepdata" :key="ind" :title="v.dict.name" v-if="v.dict.parentId===0">
						{{v.dict.name}}:
					</li>
					<li v-else-if="v.dict.parentId===1">
						<img v-if="v.obj.state===1" src="../../../static/images/savior_list_y.png" alt="">
						<img v-else src="../../../static/images/savior_list_n.png" alt=""> {{v.dict.name}}
					</li>
				</ul>
			</div>
			<p style="font-weight: 600;">案件结点流程</p>
			<br/>
			<el-table :data="tableData" border style="width: 100%" empty-text="暂无数据">
				<el-table-column prop="date" label="时间" width="180" align="center">
				</el-table-column>
				<el-table-column prop="node" label="操作节点" width="180" align="center">
				</el-table-column>
				<el-table-column prop="det" label="操作细节" align="center">
				</el-table-column>
				<el-table-column prop="field" label="操作方" align="center">
				</el-table-column>
				<el-table-column prop="moredetail" label="详细流程" align="center">
				</el-table-column>
				<el-table-column prop="corr" label="相关单据及图片" align="center" width='210'>
					<template slot-scope="scope">
						<isJpg :listArr='scope.row.corr' />
					</template>
				</el-table-column>
			</el-table>
			<div class="offer_box">
				<p>
					<small>A、救援报价</small>
				      	<span>
                    整体报价:<b>{{feedata.rescueFee + feedata.medicFee + feedata.caseFee ||0}} {{feedata.currency}}</b>
                </span>
				      	<span>
                    救援费用：<b>{{feedata.rescueFee||0}} {{feedata.currency}}</b>
                </span>
					      <span v-if="typeId != 800">
                    医疗费用：<b>{{feedata.medicFee||0}} {{feedata.currency}}</b>
                </span>
					      <span v-if="typeId != 800">
                    案件服务费用：<b>{{feedata.caseFee||0}} {{feedata.currency}}</b>
                </span>
				</p>
				<p>
					<small>B、转交报价</small>
					      <span>
                      整体报价:<b>{{confirmFee.rescueFee + confirmFee.medicFee || 0}} {{confirmFee.currency}}</b>
                </span>
				      	<span>
                      救援费用：<b>{{confirmFee.rescueFee||0}} {{confirmFee.currency}}</b>
                </span>
				      	<span v-if="typeId != 800">
                      医疗费用：<b>{{confirmFee.medicFee||0}} {{confirmFee.currency}}</b>
                </span>
				</p>
				<p  v-if="this.$route.query.sure == 1">
					<small>C、实际救援费用</small>
					      <span  v-if="typeId != 800">
                      整体报价:<b>{{caseObj.totalFee||0}} {{caseObj.currency}}</b>
                </span>
                <span  v-if="typeId == 800">
                      整体报价:<b>{{caseObj.rescueFee||0}} {{caseObj.currency}}</b>
                </span>
			      		<span>
                      救援费用：<b>{{caseObj.rescueFee||0}} {{caseObj.currency}}</b>
                </span>
				      	<span v-if="typeId != 800">
                      医疗费用：<b>{{caseObj.medicFee||0}} {{caseObj.currency}}</b>
                </span>
                <span v-if="typeId != 800">
                      案件服务费用：<b>{{caseObj.caseFee||0}} {{caseObj.currency}}</b>
                </span>
                <span v-if="typeId != 800">
                  		其他费用：<b>{{caseObj.otherFee||0}} {{caseObj.currency}}</b>
                </span>
                <span v-if="typeId == 800">
                  		客户自费：<b>{{caseObj.medicFee||0}} {{caseObj.currency}}</b>
                </span>
				</p>
			</div>
		</div>
		<div class="btnBox" v-if="this.$route.query.sure == 1">
			<button type="button" @click="sureBaojia=true">确认</button>
		</div>
		<!--确认弹窗-->
		<el-dialog class="acc_box" title="确认完成案件" :visible.sync="sureBaojia" width="1000px" center>
			<div class="text_1">
				<span>A、报价</span>
				<span class="span">整体报价: <small>{{feedata.totalFee}} {{feedata.currency}}</small></span>
				<span class="span1">救援费用: <small>{{feedata.rescueFee||0}} {{feedata.currency}}</small></span>
				<span class="span1" v-if="typeId != 800">案件费用: <small>{{feedata.caseFee||0}} {{feedata.currency}}</small></span>
				<span class="span1" v-if="typeId != 800">医疗费用: <small>{{feedata.medicFee||0}} {{feedata.currency}}</small></span>
			</div>
			<div class="text_1">
				<span>B、转交报价</span>
				<span class="span">整体报价: <small>{{confirmFee.totalFee}} {{confirmFee.currency}}</small></span>
				<span class="span1">救援费用: <small>{{confirmFee.rescueFee||0}} {{confirmFee.currency}}</small></span>
				<!--<span class="span1">案件费用: <small>{{confirmFee.caseFee||0}} {{feedata.currency}}</small></span>-->
				<span class="span1" v-if="typeId != 800">医疗费用: <small>{{confirmFee.medicFee||0}} {{confirmFee.currency}}</small></span>
			</div>
			<div class="text_1" v-if="this.$route.query.sure == 1">
				<span>C、实际救援费用</span>
				<span class="span" v-if="typeId != 800">整体报价: <small>{{caseObj.totalFee||0}} {{caseObj.currency}}</small></span>
        	<span class="span" v-if="typeId == 800">整体报价: <small>{{caseObj.rescueFee||0}} {{caseObj.currency}}</small></span>
				<span class="span1">救援费用: <small>{{caseObj.rescueFee||0}} {{caseObj.currency}}</small></span>
				<span class="span1" v-if="typeId != 800">案件费用: <small>{{caseObj.caseFee||0}} {{caseObj.currency}}</small></span>
				<span class="span1" v-if="typeId != 800">医疗费用: <small>{{caseObj.medicFee||0}} {{caseObj.currency}}</small></span>
				<span class="span1" v-if="typeId != 800">其他费用: <small>{{caseObj.otherFee||0}} {{caseObj.currency}}</small></span>
        		<span class="span1" v-if="typeId == 800">客户自费: <small>{{caseObj.medicFee||0}} {{caseObj.currency}}</small></span>
			</div>
			<div class="p_box">
				<p class="text_2">D、实际费用 <span v-if="typeId != 800">*保险公司可看到</span></p>
        <div class="checkedLi">
        	<p><b>选择币种</b></p>
        	<div class="seleceBox" @mouseleave="seleceShow=false">
        		<p @click="seleceShow=!seleceShow">{{moneyCheck}}</p>
        		<ul v-show="seleceShow">
        			<li v-for="item in moneyList" @click="selectFun(item)">{{item.name}} {{item.label}}</li>
        		</ul>
        	</div>
        </div>
				<div style="overflow: hidden;">
					<label for="jy">救援费用: 
						<input type="number" name="jy" id="jy" v-model="jytxt" placeholder='请输入金额' @change="jtfychange(jytxt)" @input="upnum(jytxt)">
						<span>{{moneySymbol || 'USD'}}</span>
					</label>
					<label for="yl" v-if="typeId != 800">
						医疗费用:<input type="number" name="yl" id="yl" v-model="yltxt" placeholder='请输入金额' @input="upnum(yltxt)">
						<span>{{moneySymbol || 'USD'}}</span>
					</label>
          	<label for="yl" v-if="typeId == 800">
						纯收入:<input type="number" name="yl" id="yl" disabled v-model="ajfwtxt" placeholder='请输入金额' @input="upnum(ajfwtxt)">
						<span>{{moneySymbol || 'USD'}}</span>
					</label>
					<label for="aj">
						客户自费:<input type="number" name="aj" id="aj" v-model="ajtxt" placeholder='请输入金额' @input="upnum(ajtxt)">
						<span>{{moneySymbol || 'USD'}}</span>
					</label>
					<label for="zt" class="input" v-if="typeId != 800">
						整体费用:<span>{{zttxt}}</span>
						<span>{{moneySymbol || 'USD'}}</span>
					</label>
          <label for="zt" class="input" v-if="typeId == 800">
						保司合作费用:
						<span>{{ztfy || 'USD'}}</span>
					</label>
          
				</div>
        <div style="height: 130px;" v-if="typeId == 800">
            <label for="yl" style="width:25%">
						备注: <el-input
              type="textarea"
              :rows="2"
              placeholder="请输入内容"
              v-model="closeText">
            </el-input>
						<!-- <span>{{moneySymbol || 'USD'}}</span> -->
					</label>
           <div style="display: inline-block;color:#ccc;margin-left: 2%;" >
               <div>备注输入内容例如：紧急开锁</div>
               <div >*安排师傅提供服务，服务完成，回访客户，客户满意。</div>
        <div>*服务完成，客户自付（**元），回访客户，客户满意。</div>
        <div>*客户有异议</div>
        </div>
        <div style="display: inline-block;color:#ccc" >
            <div>*备注输入内容例如：马桶疏通</div>
               <div >*安排师傅提供服务，服务完成，回访客户，客户满意。</div>
        <div>*服务完成，客户自付（**元），回访客户，客户满意。</div>
        <div>*客户有异议</div>
       
        </div>
      
        </div>
	      
				<!--<el-input rows="3" type="textarea" placeholder="其他费用说明" v-model="qt"></el-input>-->
				<p class="p">
					<el-button center type="primary" @click="accup()">确认完成</el-button>
				</p>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import qs from "qs";
	import constants from '@/util/constants.js';
	import process from './../process/index1'
	import { getfinishSureCase,getCasedetail1,regulatorlistservice } from '@/views/axios/api.js';
	import ParheaderVue from "../par/parheader.vue";
	import Parinf from "../par/Parinf.vue";
  // 	import ParheaderVue from ".@/views/commonPage/details/parheader.vue";
	// import Parinf from ".@/views/commonPage/details/Parinf.vue";
	export default {
		data() {
			return {
        ztfy:0,
        accidentType:'',
        detailList:[],
				token: this.$route.params.token || JSON.parse(window.localStorage.getItem("data")).data,
				caseid: this.$route.query.caseid,
				stepdata: [],
				centerDialogVisible: false,
				feedata: {
					totalFee: 0,
					rescueFee: 0,
					medicFee: 0,
					caseFee: 0
				},
				caseObj: [],
				confirmFee: {},
				tableData: [],
				imageUrl: "",
				el_index: 0,
				typeId: this.$route.query.typeId,
				imgList:[],//图片列表
				sureBaojia:false,
				jytxt:0,
				yltxt:0,
				ajtxt:0,
				qttxt:0,
				zttxt:0,
        ajfwtxt:0,
        closeText:'',
				qt:'',
        moneyList: [{
        		name: '人民币',
        		nameEn: 'Ren Min Bi',
        		label: 'RMB'
        	},
        	{
        		name: '美元',
        		nameEn: 'U.S. Dollar',
        		label: 'USD'
        	},
        	{
        		name: '欧元',
        		nameEn: 'Euro',
        		label: 'EUR'
        	},
        	{
        		name: '日元',
        		nameEn: 'Japanese Yen',
        		label: 'JPY'
        	},
        	{
        		name: '新台币',
        		nameEn: 'New Taiwan Currency',
        		label: 'TWD'
        	}
        ],
        seleceShow:false,
        moneyCheck:'',
        moneySymbol:''
			};
		},
		components:{
			process,
			ParheaderVue,
			Parinf
		},
		methods: {
      jtfychange(jyfy) {
        this.ajfwtxt = this.ztfy - jyfy
      },
       getCasedetail(){//获取详情
        var data = {
        	token: this.token,
        	caseId: this.$route.query.caseid
        };
        getCasedetail1(data)
        .then(res => {
          console.log(res,'getCasedetail1getCasedetail1getCasedetail1');
         
          // this.detailList=this.detailLists[this.activeIndex];
        console.log(this.detailList)
        })
      },
      selectFun(item) {
      	this.moneyCheck = item.name + " " + item.label;
      	this.seleceShow = false;
      	this.moneySymbol = item.label;
      },
			back() {
				this.$router.push({
					name: "ComRescue",
					params: {
						token:JSON.parse(window.localStorage.getItem("data")).data,
						caseid: this.caseid
					},
					query: {
						typeId: this.typeId
					}
				});
			},
			isImg(url){
				return constants.isPic(url)?url:'../../../../static/images/eles_icon.png'
			},
			upnum(val) {
				if(isNaN(val)) {
					this.$message.error("请输入数字，而非其他");
				} else {
					if(!this.jytxt) {
						this.jytxt = 0;
					}
					if(!this.yltxt) {
						this.yltxt = 0;
					}
					if(!this.ajtxt) {
						this.ajtxt = 0;
					}
					if(!this.qttxt) {
						this.qttxt = 0;
					}
          if(!this.ajfwtxt) {
            	this.ajfwtxt = 0;
          }
					this.jytxt = this.jytxt * 1;
					this.yltxt = this.yltxt * 1;
					this.ajtxt = this.ajtxt * 1;
					this.qttxt = this.qttxt * 1;
          this.ajfwtxt = this.ajfwtxt * 1;
					this.zttxt = (this.jytxt + this.yltxt + this.ajtxt + this.qttxt + this.ajfwtxt).toFixed(2);
				}
			},
			accup(){
        if(this.typeId == 800) {
          var data={
					token:this.token,
					id: this.caseid,
					rescueFee:this.jytxt,//救援费用
					medicFee:this.ajtxt,//医疗费用
					otherFee:this.ajfwtxt,//其他费用
					totalFee:this.zttxt,//整体费用
          caseFee:this.ajfwtxt,
          closeText:this.closeText,
          currency:this.moneySymbol
				}
        }else {
           var data={
					token:this.token,
					id: this.caseid,
					rescueFee:this.jytxt,//救援费用
					medicFee:this.yltxt,//医疗费用
					otherFee:this.ajtxt,//其他费用
					totalFee:this.zttxt,//整体费用
          caseFee:this.ajfwtxt,
          closeText:this.closeText,
          currency:this.moneySymbol
				}
        }
				
				getfinishSureCase(data)
				.then(res=>{
					if(res.data.msg == 'ok'){
						this.$message({
				          message: '操作成功',
				          type: 'success'
				        });
                if(this.typeId != 800) {
                  this.$router.push({
                          path: '/cmd_center/caseDetails',
                          query: {
                            caseid: this.caseid
                          },
                        });
                }else {
                  this.$router.push({
                    path: '/branch/starindex/Homestart3',
                    query: {
                      typeId:800,
                      t:0
                    },
                  });
                }
        
               
				        // this.$router.go(-1)
					}

				})
				.catch(err=>{
					console.log(err)
				})
			},
			getData(){
			let that = this;
			that.caseObj={};
			that.feedata={};
			that.stepdata=[];
			that.confirmFee={};
			that.tableData=[];
			this.axios
				.post(
					constants.domain + "rescue/case/detail_case",
					qs.stringify({
						token: that.token,
						caseId: that.caseid
					})
				)
				.then(res => {
           console.log(res.data.obj.obj.accidentType)
           this.accidentType = res.data.obj.obj.accidentType
					that.caseObj = res.data.obj.feelst[0];
          this.jytxt = that.caseObj.rescueFee;//救援费用
          this.yltxt = that.caseObj.medicFee//医疗费用
        if(this.typeId == 800) {
          console.log(res.data.obj.obj.subRegulatorId,res.data.obj.obj.regulatorId)
          if(res.data.obj.obj.subRegulatorId != '' && res.data.obj.obj.subRegulatorId != null && res.data.obj.obj.subRegulatorId != undefined) {
            regulatorlistservice({
            token:JSON.parse(window.localStorage.getItem("data")).data,
            regulatorId:res.data.obj.obj.regulatorId,
            subRegulatorId:res.data.obj.obj.subRegulatorId
          }).then((res1)=>{
            console.log(res1.data.obj[i],1111111111111)
            for(var i = 0; i<res1.data.obj.length; i++) {
              if(res1.data.obj[i].serviceType == this.accidentType) {
                this.ztfy = res1.data.obj[i].amount
                console.log(res1.data.obj[i].amount - this.jytxt)
                this.ajfwtxt = res1.data.obj[i].amount - this.jytxt
              }
            }
          })
          }
         
            // if(this.accidentType=="马桶疏通" || this.accidentType == '油烟机清洗'|| this.accidentType == '油烟机拆洗' || this.accidentType == '保洁2小时' || this.accidentType == '保洁4小时' || this.accidentType == '擦玻璃小户型（100平米下）'|| this.accidentType == '擦玻璃大户型（100-150平米）'){
            //       this.ajfwtxt = 41
            //   }else {
            //       this.ajfwtxt = 99
            //   }
            this.ajtxt = that.caseObj.medicFee;//其他费用
        }else {
            this.ajtxt = that.caseObj.otherFee//其他费用
        }
           	
         
				
					this.zttxt = that.caseObj.totalFee,//整体费用
          // this.ajfwtxt = that.caseObj.caseFee,
             console.log(that.caseObj)
				});

			this.axios
				.post(
					constants.domain + "rescue/bidding/view_case_solution",
					qs.stringify({
						token: that.token,
						caseId: that.caseid
					})
				)
				.then(res => {
					console.log(res.data)
					that.flag = true;
					that.feedata = res.data.obj;
					that.stepdata = res.data.obj2;
					for(var i = 0; i < that.stepdata.length; i++) {
						var o = that.stepdata[i].obj;
						if(o.state && o.state == 1) {
							that.el_index += 1;
						}
					}
					that.loading = false;
				});

			this.axios
				.post(
					constants.domain + "rescue/bidding/view_case_solution",
					qs.stringify({
						token: that.token,
						caseId: that.caseid,
						state: 4
					})
				)
				.then(res => {
					this.confirmFee = res.data.obj;
          this.moneyCheck = this.moneyList.find(item => {
          	return item.label == this.confirmFee.currency
          }).name + " " + this.confirmFee.currency;
          this.moneySymbol=this.confirmFee.currency
				});
			var data={
				token: that.token,
				caseId: that.caseid,
			}
			this.axios
				.post(
					constants.domain + "rescue/case/case_progress",
					qs.stringify({
						token: this.token,
						caseId: this.caseid
					})
				)
				.then(data => {
					data.data.obj.map((v, i) => {
						let type = "";
						if(v.obj.operatorType === 0) {
							type = "供应商";
						} else if(v.obj.operatorType === 1) {
							type = "";
						} else if(v.obj.operatorType === 2) {
							type = "监管机构";
						}
						var corr = [];
						if(v.obj.opPhotoUrls) {
							corr = JSON.parse(v.obj.opPhotoUrls);
						}
						var address='';
						if(v.obj.opDesc){
							if(!constants.setTxt(v.obj.opDesc,'zh')){
								address=v.obj.opDesc
							}else{
								address=that.languageIndex== 0 ? constants.setTxt(v.obj.opDesc,'zh') : constants.setTxt(v.obj.opDesc,'en')
							}
						}
						var moredetailList=''
						if(v.moredetail){
							v.moredetail.forEach((item,index) => {
								if(!constants.setTxt(item,'zh')){
									moredetailList=item
								}else{
									if(that.languageIndex == 0){
										moredetailList +=v.moreTime[index] + constants.setTxt(item,'zh')+'\n'
									}else{
										moredetailList +=v.moreTime[index] + constants.setTxt(item,'en')+'\n'
									}
								}
							})
						}
						that.tableData.push({
							date: constants.time(v.obj.updateAt),
							node: v.obj.opStateText,
							det: address,
							field: type + " " + v.instiName,
							moredetail: moredetailList,
							corr: corr
						});
					});
				});
         
      }
      
		},
		mounted() {
			this.getData()
      this.getCasedetail()
		},
		computed: {
			languageIndex() {
				return this.$store.state.language
			}
		},
		watch:{
			languageIndex(){
				this.getData()
			}
		}
	};
</script>

<style scoped>
	.offer_box {
		line-height: 50px;
	}

	.offer_box p {
		line-height: 50px;
    border: 1px solid #eee;
		border-top: 0;
		padding-left: 10px;
	}

	.offer_box p small {
		display: inline-block;
		width: 140px;
		font-size: 16px;
	}

	.offer_box span {
		margin-left: 35px;
		color: #333;
		font-size: 16px;
	}

	.offer_box span b {
		color: #ff7200;
		margin-left: 3px;
	}

	span {
    		font-size: 14px;
	}

	span small {
		color: #ff7200;
	}

	.acc_box .span {
		margin-left: 10px;
		color: #333;
	}

	.rspan {
		color: #df1717;
	}

	.upspan {
		font-size: 64px;
	}

	label {
		display: block;
		float: left;
		width: 33%;
		margin-top: 10px;
		margin-bottom: 10px;
		margin-left: 2px;
	}

	label input {
		width: 130px;
		margin-left: 5px;
		height: 25px;
		border: 0;
		border-radius: 3px;
		border: 1px solid #ccc;
	}

	.p {
		text-align: center;
	}

	.a-upload {
		padding: 4px 10px;
		height: 20px;
		line-height: 20px;
		position: relative;
		cursor: pointer;
		color: #888;
		background: #fafafa;
		border: 1px solid #ddd;
		border-radius: 4px;
		overflow: hidden;
		display: inline-block;
		*display: inline;
		*zoom: 1;
	}

	.a-upload input {
		position: absolute;
		font-size: 100px;
		right: 0;
		top: 0;
		opacity: 0;
		filter: alpha(opacity=0);
		cursor: pointer;
	}

	.a-upload:hover {
		color: #444;
		background: #eee;
		border-color: #ccc;
		text-decoration: none;
	}
	.res_box {
		text-align: left;
	}

	p {
		line-height: 25px;
	}

	.det_box {
		box-sizing: border-box;
		padding: 10px 15px;
	}

	.det_box ul {
		width: 100%;
	}
	.back_box {
		text-align: left;
		font-size: 14px;
		line-height: 45px;
		color: #666;
		cursor: pointer;
	}

	.res_box>h2 {
		font-size: 20px;
		color: #333;
		font-weight: 600;
		line-height: 45px;
	}

	.box {
		margin-left: 100px;
		margin-top: -20px;
	}

	.a_box {
		position: absolute;
		top: 330px;
		width: 50%;
		left: 700px;
		height: 100px;
  	}

	.f_box {
		position: absolute;
		width: 300px;
		/* left: 280px; */
		bottom: 0;
	}

	.f_box input {
		display: block;
	}

	.acc {
		margin-top: 80px;
	}

	.imgbox {
		width: 80px;
		height: 80px;
		border: 1px solid #ccc;
		display: block;
	}

	.f_box>span {
		color: #00abfa;
		margin-left: 18px;
	}

	.ul {
		height: 50px;
	}

	.ul>li {
		text-align: center;
		float: left;
		margin-left: 10px;
		width: 15%;
	}

	.ul>li:first-child {
		width: 10%;
		font-weight: 600;
	}

	.ul>li p {
		width: 100%;
		text-align: center;
	}

	.up_box {
		width: 80px;
		height: 80px;
		border: 1px solid #ccc;
		display: block;
		font-size: 64px;
		color: #ccc;
		text-align: center;
		line-height: 80px;
	}

	.img_box img {
		width: 80px;
		height: 80px;
		margin: 5px;
	}

	.img_box {
		position: absolute;
		top: -20px;
	}

	.imgList {
		width: 244px;
		margin-right: 10px;
		margin-bottom: 10px;
		border-radius: 5px;
	}

	.overflow {
		width: 198px;
		text-align: left;
		cursor: pointer;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap
	}

	.overflow div {
		margin-right: 10px;
		width: 50px;
		display: inline-block;
		vertical-align: middle;
	}

	.overflow div p {
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	.overflow .err img {
		height: 23px;
		width: 13px;
	}
	.btnBox{text-align: center;margin-top: 40px;}
	.btnBox button{width: 160px;height: 40px;border: none;background-color: #409EFF;color: white;border-radius: 5px;cursor: pointer;}
	.p{margin-top: 20px;}
	.text_1{margin-bottom: 20px;}
	.text_1 span{display: inline-block;width: 150px;font-size: 16px;}
	.text_1 .span1{color: #999;}
	.text_2 span{font-size: 14px;color: #fc585c;}
	.p_box input{outline: none;padding:0 10px;}
  .checkedLi {
  	height: 42px;
  }
  .checkedLi p {
  	float: left;
  	line-height: 30px;
  	font-size: 14px;
  }
  .checkedLi .seleceBox {
  	float: left;
  	margin-left: 10px;
  }
  .seleceBox {
  	position: relative;
  	padding-bottom: 10px;
  }
  .seleceBox ul {
  	position: absolute;
  	top: 39px;
  	left: 0;
  	border: 1px solid #d9ddde;
  	width: 150px;
  	z-index: 2;
  	background-color: white;
  	border-radius: 3px;
  }

  .seleceBox p {
  	width: 140px;
  	height: 30px;
  	line-height: 30px;
  	border: 1px solid #d9ddde;
  	padding-left: 10px;
  	border-radius: 5px;
  	font-size: 14px;
  	color: #999;
  	background: url('./../../assets/img/downErr.png') no-repeat 125px center;
  	cursor: pointer;
  }

  .seleceBox ul li {
  	line-height: 30px;
  	padding-left: 10px;
  	font-size: 14px;
  	color: #999;
  }
  .seleceBox ul li:hover {
  	background-color: #f6f6f6;
  	cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/cmd_center/resstep.vue